module.exports = "/images/line.png?78882adca3df4b768aa177771fdabc56";